import colors, { palette } from '../colors';
export default {
  main: {
    color: palette.primary
  },
  fileList: {},
  icons: {
    main: {
      fill: palette.primary,
      stroke: colors.white,
      hover: {
        borderColor: palette.primary
      },
      fileDragged: {},
      defaultBorder: {}
    },
    uploadIcon: {},
    errorIcon: {},
    success: {}
  },
  wrapper: {},
  caption: {},
  strong: {
    color: palette.primary
  },
  progressBarForeground: {
    background: palette.primary
  },
  progressBarBackground: {
    background: palette.primary
  },
  file: {
    fileName: {
      color: colors.dark
    },
    fileWrapper: {},
    fileSize: {},
    errorMessage: {},
    descriptionError: {},
    progressWrapper: {}
  },
  defaultText: {},
  deleteWrapper: {}
};